import { render, staticRenderFns } from "./ManagementHospitality.vue?vue&type=template&id=543ac731&scoped=true&"
import script from "./ManagementHospitality.vue?vue&type=script&lang=ts&"
export * from "./ManagementHospitality.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementHospitality.vue?vue&type=style&index=0&id=543ac731&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ac731",
  null
  
)

export default component.exports